module.exports = __webpack_public_path__ + "static/media/cal.1478f058.svg";